<script>
  import { onMount } from 'svelte'
  import { Link } from 'svelte-routing'
  import { _ } from 'svelte-i18n'
  import LeftSidebarSkeleton from '../../Components/LeftSidebarSkeleton.svelte'
  let data = {}
  let loadingSidebar = true
  async function getData() {
    let location = await localStorage.getItem('LANGUAGE') || 'es-CL';
    if (location === 'es') {
      location = 'es-CL';
    }
    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
    }
    fetch(
      `https://api.rastros.cl/api/home-screen?populate=%2A&locale=${location}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((result) => {
        data = result.data;
        loadingSidebar = false;
      })
      .catch((error) => {
        console.error('Error al contactar al servicio de home-screen en Navbar:', error);
        data = {}; // Initialize data as an empty object to prevent TypeError
        loadingSidebar = false;
      })
  }

  let currentPath = window.location.pathname

  onMount(async () => {
    await getData()
  })
</script>

{#if loadingSidebar}
  <!-- Si aún carga, mostramos el skeleton -->
  <LeftSidebarSkeleton />
{:else}
  <!-- Una vez cargada la data, se muestra el sidebar real -->
  <div class="vertical-menu">
    <div data-simplebar class="h-100">
      <div id="sidebar-menu">
        <ul class="metismenu list-unstyled" id="side-menu">
          <li class="menu-title" key="t-menu">{data.subtitle}</li>

          <li class={currentPath == '/' ? 'mm-active' : ''}>
            <Link class="side-nav-link-ref" to="/">
              <i class="bx bx-home" />
              <span key="t-home">{data.menuHomeOption}</span>
            </Link>
          </li>

          <li class={currentPath == '/alert' ? 'mm-active' : ''}>
            <Link class="side-nav-link-ref" to="/alert">
              <i class="bx bx-message-rounded-dots" />
              <span key="t-alert">{data.menuAlertOption}</span>
            </Link>
          </li>

          <!--li class={currentPath == '/tanque-proceso' ? 'mm-active' : ''}>
            <Link class="side-nav-link-ref" to="tanque-proceso">
              <i class="bx bx-gas-pump" />
              <span key="t-tank">{data.menuTankOption}</span>
            </Link>
          </!--li>

          <li class={currentPath == '/origen' ? 'mm-active' : ''}>
            <Link class="side-nav-link-ref" to="/origen">
              <i class="bx bx-map" />
              <span key="t-origen">{data.StackedColumnChart}</span>
            </Link>
          </li>

          <li class={currentPath == '/destinos' ? 'mm-active' : ''}>
            <Link class="side-nav-link-ref" to="/destinos">
              <i class="bx bx-map-alt" />
              <span key="t-destinos">{data.menuDestinationChart}</span>
            </Link>
          </li>

          <li class={currentPath == '/dispositivo' ? 'mm-active' : ''}>
            <Link class="side-nav-link-ref" to="/dispositivo">
              <i class="bx bx-sitemap" />
              <span key="t-dispositivo">{data.menuDeviceChart}</span>
            </Link>
          </li>
          <li class={currentPath == '/camion' ? 'mm-active' : ''}>
            <Link class="side-nav-link-ref" to="/camion">
              <i class="bx bx-taxi" />
              <span key="t-camion">{data.menuTrucksChart}</span>
            </Link>
          </li>
          <li-- class={currentPath == '/compania' ? 'mm-active' : ''}>
            <Link class="side-nav-link-ref" to="/compania">
              <i class="bx bx-copyright" />
              <span key="t-compania">{data.menuCompanyChart}</span>
            </Link>
          </li-->
        </ul>
      </div>
    </div>
  </div>
{/if}

<style>
  /* Tus estilos para el sidebar real */
</style>
